import { useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useFair } from '../api/FairProvider';
import { siblingFlagUrl } from '../utils/flag';

import { FairsModal } from './FairsModal';

export interface FairFlagButtonProps {
  /** Tailwind size class for the flag disc; page titles vary slightly. */
  className?: string;
}

/**
 * The current fair's flag, shown beside a page title. Away from the home screen
 * this is how a visitor switches country, so it opens the exhibitor menu rather
 * than sitting there as decoration.
 */
export function FairFlagButton({ className = 'size-7' }: FairFlagButtonProps): ReactElement {
  const { t } = useTranslation();
  const { currentSibling } = useFair();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setOpen(true);
        }}
        aria-label={t('fairs.title')}
        aria-haspopup="dialog"
        aria-expanded={open}
        className="rounded-full transition-opacity hover:opacity-80"
      >
        <img src={siblingFlagUrl(currentSibling)} alt="" className={`${className} rounded-full`} />
      </button>

      <FairsModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
